import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { formatDateWithoutTime } from "../../utils/formateDate";

const SubscriptionExpiryDialog = ({ show, onHide, productValidity }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRenewNow = () => {
    onHide();
    navigate("/renew?previousPage=/dashboard");
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop={true}
      keyboard={true}
      size="md"
      className="subscription-expiry-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i
            className="fa-solid fa-triangle-exclamation"
            style={{ color: "#e0a800", marginInlineEnd: "8px" }}
          ></i>
          {t("subscription_expired_title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>{t("subscription_expired_message")}</strong>
        </p>
        {productValidity && (
          <p style={{ marginBottom: "12px" }}>
            <span>{t("expiry")}: </span>
            <strong>{formatDateWithoutTime(productValidity)}</strong>
          </p>
        )}

        <p style={{ marginBottom: "8px" }}>
          {t("subscription_expired_no_commissions")}
        </p>
        <ul style={{ paddingInlineStart: "20px", marginBottom: "16px" }}>
          <li>{t("subscription_expired_lost_direct")}</li>
          <li>{t("subscription_expired_lost_levels")}</li>
          <li>{t("subscription_expired_lost_infinity")}</li>
          <li>{t("subscription_expired_lost_other")}</li>
        </ul>

        <p style={{ marginBottom: "8px" }}>
          <strong>{t("subscription_renew_steps_title")}</strong>
        </p>
        <ol style={{ paddingInlineStart: "20px", marginBottom: 0 }}>
          <li>{t("subscription_renew_step_1")}</li>
          <li>{t("subscription_renew_step_2")}</li>
          <li>{t("subscription_renew_step_3")}</li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("close")}
        </Button>
        <Button variant="primary" onClick={handleRenewNow}>
          {t("renew_now")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SubscriptionExpiryDialog;
